// extracted by mini-css-extract-plugin
export var completionBody = "_ko-2";
export var completionCard = "_ko-0";
export var completionFooter = "_ko-3";
export var completionTitle = "_ko-1";